import { Injectable } from '@angular/core';
import {
  AuthConfig,
  NullValidationHandler,
  OAuthService,
} from 'angular-oauth2-oidc';

import { IdentificationProviderService, User } from './identification-provider.service';

@Injectable()
export class AuthConfigService {
  constructor(
    private readonly oauthService: OAuthService,
    private readonly authConfig: AuthConfig,
    private readonly identificationProviderService: IdentificationProviderService
  ) {}

  async initAuth(): Promise<void> {
    return new Promise((resolveFn, rejectFn) => {
      // Setup oauthService
      this.oauthService.configure(this.authConfig);
      this.oauthService.setStorage(localStorage);
      this.oauthService.tokenValidationHandler = new NullValidationHandler();
      this.oauthService.redirectUri = window.location.href.replace(window.location.search,'');

      this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
        if (this.oauthService.hasValidIdToken()) {
          const jwtToken = this.oauthService.getIdToken();
          this.oauthService.setupAutomaticSilentRefresh();

          if (jwtToken) {
            this.identificationProviderService.setUser(new User(jwtToken));
          }
        }
        resolveFn();
      });
    });
  }
}
